// UserInfoView.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import {
    DialogContent, DialogActions, Button, Grid,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import NoAccountsIcon from '@mui/icons-material/NoAccounts'; // 사용중지.
import { AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { VzmPrint } from '../../common/VzmStyled';
import { UserInfoDictionary } from './UserInfoDict';
import DraggableViewer from '../../common/DraggableViewer';
import { useAuthorizationCheck } from '../../api/app-hook';
import ValueMisc from '../../value/ValueMisc';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    marginTop: 10
});

const InputMap = UserInfoDictionary.viewMap;

/**
 * (USER_INFO) 정보 상세보기
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-09-19 11:09:47 using DbdbTap
 */
export default function UserInfoView({
    open,
    item,
    onRequestEdit,
    onClose
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();

    if(!open || !item) return null;

    const renderOrg = (item) => {
        if(ValueMisc.isStoreClassId(item.authClassId)) {
            return(
                <VzmPrint label={InputMap.storeName.label} value={item.storeName} />
            );
        }
        else if(ValueMisc.isTruckCompanyClassId(item.authClassId)) {
            return(
                <VzmPrint label={InputMap.comName.label} value={item.comName} />
            );
        }
        else {
            return(
                <VzmPrint label={InputMap.dcName.label} value={item.dcName} />
            );
        }
    };

    const canEdit = checkAuth(authTableTree.tree.pr_user_info_edit);

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='md'
            startIcon={
                item.useYn==='N' ?
                <NoAccountsIcon fontSize={AppWord.LARGE} style={{color:'orange', marginRight:15}}/>
                :
                <ContactPageIcon fontSize={AppWord.LARGE} style={{color:'white', marginRight:15}}/>
            }
            title={`${item.userName} 상세정보`}
        >
            <DialogContent>
                <ViewContainer>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <VzmPrint label={InputMap.userName.label} value={item.userName} />
                        </Grid>
                        <Grid item xs={5}>
                            <VzmPrint label={InputMap.userId.label} value={item.userId} />
                        </Grid>
                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.className.label} value={item.className} />
                        </Grid>
                        <Grid item xs={4}>{renderOrg(item)}</Grid>

                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.zipCd.label} value={item.zipCd} />
                        </Grid>
                        <Grid item xs={9}>
                            <VzmPrint label={InputMap.addr.label} value={item.addr} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.telno.label} value={item.telno} />
                        </Grid>
                        <Grid item xs={8}></Grid>
                        <Grid item xs={12}>
                            <VzmPrint label={InputMap.email.label} value={item.email} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.allDcYn.label} value={item.allDcYn==='Y' ? '전체' : '소속DC구분'} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.useYn.label} value={item.useYn==='Y' ? '사용' : '사용중지'} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.handlerYn.label} value={item.handlerYn==='Y' ? '취급' : '불허'} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label='마지막 로그인' value={item.loginTime} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.loginCnt.label} value={item.loginCnt} />
                        </Grid>
                        <Grid item xs={4}></Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.regType.label} value={item.regType} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label="등록" value={item.regDate} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label="등록자" value={item.regUserName} />
                        </Grid>
                    </Grid>
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                {
                    canEdit ?
                    <Button
                        onClick={()=>{onRequestEdit(item)}}
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        sx={{width: 120, marginRight: 1}}
                        startIcon={<EditIcon />}
                    >
                        편집
                    </Button>
                    : null
                }
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );

}